import { RDocument } from "@/components/DocumentViewCards/RDocument";
import { RouteConfig } from "vue-router";
import { REmployeeProfileDocumentsBrowse } from "./components/REmployeeProfileDocumentsBrowse";
import { RUploadDocuments } from "@/modules/Documents/Upload/RUploadDocuments";

export const REmployeeProfileDocuments: RouteConfig = {
  path: "documents",
  component: () =>
    import(
      /* webpackChunkName: "employee-profile-documents" */
      "./VEmployeeProfileDocuments.vue"
    ),
  meta: {
    title: "My Profile",
    label: "documents",
  },
  children: [REmployeeProfileDocumentsBrowse, RDocument, RUploadDocuments],
};
